import React from "react";
import DashboardContainer from "components/Dashboard/DashboardContainer";
import { useAppMeta } from "hooks";
import { VendorAnalyticOverview } from "components/Dashboard/VendorAnalyticOverview";
import { useGetVendorCODChargeOverviewQuery, useGetVendorProfileDashboardStatsQuery } from "store/services/dashboardApi";
import DashboardHeading from "components/Dashboard/DashboardHeading";
import VendorPaymentChargeOverVIew from "components/Dashboard/VendorPaymentChargeOverVIew";

export const VendorDashboardScreen = () => {
  const {
    data: fetchStatsData,
    isLoading: StatsLoading,
    isFetching: fetchingDashboard,
  } = useGetVendorProfileDashboardStatsQuery();

  const {
    data: codChargeData,
    isLoading: codChargeLoading,
    isFetching: codChargeFetching,
  } = useGetVendorCODChargeOverviewQuery();

  useAppMeta("Vendor Dashboard");

  return (
    <DashboardContainer>
      <div>
        <DashboardHeading />
      </div>
      <div>
        <VendorAnalyticOverview
          statsData={fetchStatsData}
          isLoading={StatsLoading || fetchingDashboard}
        />
      </div>
      <div className="mt-4">
        <VendorPaymentChargeOverVIew
          statsData={codChargeData}
          isLoading={codChargeLoading || codChargeFetching}
        />
      </div>
    </DashboardContainer>
  );
};
